import React from "react";
import { FaCode, FaHtml5, FaReact } from "react-icons/fa";
import { SiTailwindcss } from "react-icons/si";
import ServiceItem from "./ServiceItem";

const serviceData = [
  {
    id: 1,
    icon: <FaCode />,
    title: "Responsive Design",
    description:
      "Creating clean, modern interfaces with HTML5, CSS3, and Tailwind CSS. Focus on pixel-perfect layouts and seamless user experiences across all devices.",
  },
  {
    id: 2,
    icon: <FaHtml5 />,
    title: "Full Stack Development",
    description:
      "Building complete web applications with JavaScript/TypeScript, React, and backend technologies. From database design to deployment, end-to-end solutions.",
  },
  {
    id: 3,
    icon: <FaReact />,
    title: "Frontend Development",
    description:
      "Specialized in React, modern JavaScript frameworks, and interactive UIs. Strong focus on performance optimization and clean component architecture.",
  },
  {
    id: 4,
    icon: <SiTailwindcss />,
    title: "UI/UX Implementation",
    description:
      "Turning designs into functional, accessible web applications using Tailwind CSS and best practices in web accessibility and performance.",
  },
  {
    id: 5,
    icon: <FaCode />,
    title: "Problem Solving",
    description:
      "Algorithmic thinking and debugging expertise. Proficient in solving complex problems with C, C++, and JavaScript.",
  },
  {
    id: 6,
    icon: <FaReact />,
    title: "Peer Collaboration",
    description:
      "Experienced in collaborative learning and peer reviews from the 42 School program. Strong communication and teamwork skills.",
  },
];

const Service = () => {
  return (
    <section className="pb-10">
      <div className="flex flex-wrap md:px-4">
        {serviceData.map((service, id) => (
          <ServiceItem service={service} key={id} />
        ))}
      </div>
    </section>
  );
};

export default Service;
